import { render } from "./customizerOpen.vue?vue&type=template&id=4ca6f58b"
import script from "./customizerOpen.vue?vue&type=script&lang=js"
export * from "./customizerOpen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__